/**
 * Reset documents utility
 * This will clear the existing documents and reinitialize with only 5 documents
 */

// Generate dates within a range
const randomDate = (start, end) => {
  const startDate = start || new Date(new Date().setDate(new Date().getDate() - 30));
  const endDate = end || new Date();
  return new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime())).toISOString().split('T')[0];
};

// Document statuses with weighted probability
const documentStatuses = ['paid', 'paid', 'paid', 'pending', 'pending', 'overdue'];

// Reset documents to only 5
export const resetDocuments = () => {
  // Get existing clients and products
  const clientsData = localStorage.getItem('facit_clients');
  const productsData = localStorage.getItem('facit_products');
  
  const clients = clientsData ? JSON.parse(clientsData) : [];
  const products = productsData ? JSON.parse(productsData) : [];
  
  if (clients.length === 0 || products.length === 0) {
    console.error('Cannot reset documents: clients or products data not found');
    return false;
  }
  
  // Generate 5 new documents
  const documents = generateFiveDocuments(clients, products);
  
  // Save to localStorage
  localStorage.setItem('facit_documents', JSON.stringify(documents));
  
  // Reset initialization flag to force reload
  localStorage.setItem('facit_initialized', 'true');
  
  console.log('Documents reset to 5 items');
  return true;
};

// Generate 5 documents with realistic data
const generateFiveDocuments = (clients, products) => {
  const documents = [];
  const categories = ['FACTURATION', 'OFFRES COMMERCIALES', 'LOGISTIQUE'];
  const types = ['invoice', 'quote', 'proforma', 'delivery', 'purchase_order'];
  const titles = {
    invoice: ['Facture Développement Web', 'Facture Matériel IT', 'Facture Formation', 'Facture Services Cloud'],
    quote: ['Devis Système de Gestion', 'Devis Infrastructure IT', 'Devis Services Cloud'],
    proforma: ['Facture Proforma Formation', 'Facture Proforma Matériel IT'],
    delivery: ['Bon de Livraison Matériel', 'Bon de Livraison Équipements'],
    purchase_order: ['Bon de Commande Serveurs', 'Bon de Commande Formation', 'Bon de Commande Licences']
  };
  
  // Generate documents for past 6 months
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 6);
  
  // Ensure we have one of each main document type
  const mainTypes = ['invoice', 'quote', 'proforma', 'delivery', 'purchase_order'];
  
  for (let i = 1; i <= 5; i++) {
    // Use specific type for first 5 documents to ensure variety
    const type = i <= mainTypes.length ? mainTypes[i-1] : types[Math.floor(Math.random() * types.length)];
    const category = categories[Math.floor(Math.random() * categories.length)];
    const clientId = Math.floor(Math.random() * clients.length) + 1;
    const client = clients.find(c => c.id === clientId) || clients[0];
    const date = randomDate(startDate);
    const titleOptions = titles[type] || titles.invoice;
    const title = titleOptions[Math.floor(Math.random() * titleOptions.length)];
    const status = documentStatuses[Math.floor(Math.random() * documentStatuses.length)];
    
    // Generate items using product data
    const itemCount = Math.floor(Math.random() * 3) + 1;
    const items = [];
    let totalAmount = 0;
    
    for (let j = 0; j < itemCount; j++) {
      const product = products[Math.floor(Math.random() * products.length)];
      const quantity = Math.floor(Math.random() * 5) + 1;
      const item = {
        id: j + 1,
        name: product.name,
        quantity,
        price: product.price
      };
      items.push(item);
      totalAmount += item.price * item.quantity;
    }
    
    // Create document
    documents.push({
      id: i,
      type,
      number: `${type === 'invoice' ? 'FAC' : type === 'quote' ? 'DEV' : type === 'proforma' ? 'PRO' : type === 'delivery' ? 'BL' : 'BC'}-${1000 + i}`,
      title,
      client: client.name,
      date,
      dueDate: type === 'invoice' ? new Date(new Date(date).setDate(new Date(date).getDate() + 30)).toISOString().split('T')[0] : undefined,
      validUntil: type === 'quote' ? new Date(new Date(date).setDate(new Date(date).getDate() + 30)).toISOString().split('T')[0] : undefined,
      amount: totalAmount,
      status,
      category,
      items
    });
  }
  
  return documents;
};

// Execute reset immediately if this script is imported directly
if (typeof window !== 'undefined') {
  resetDocuments();
} 